import { useTranslation } from 'react-i18next';
import { useUpdateInvitationGroupInvitees } from './updateInvitationGroupInviteePanel/utility/useUpdateInvitationGroupInvitees';
import {
  DefaultButton,
  Dropdown,
  Panel,
  PanelType,
  PrimaryButton,
  Spinner,
  SpinnerSize,
} from 'office-ui-fabric-react';
import { mapInvitationGroupToDropdown } from '../../invitationGroupAdministrationPage/utility/mapEntities';
import { noSelectionKey } from '../../../../../utilities/filterAndSortingsUtil';

const UpdateInvitationGroupInviteePanel = ({
  hearingId,
  selectedInvitationSource,
  invitationGroups,
}) => {
  const { t: translator } = useTranslation();

  const {
    isPanelOpen,
    onPanelClose,
    selectedInvitationGroupId,
    setSelectedInvitationGroupId,
    onConfirm,
    isUpdating,
  } = useUpdateInvitationGroupInvitees(hearingId, selectedInvitationSource);

  const onChange = (_, item) => {
    setSelectedInvitationGroupId(item.key);
  };

  return (
    <div>
      <Panel
        isOpen={isPanelOpen}
        type={PanelType.medium}
        onDismiss={onPanelClose}
        isLightDismiss={true}
        onOuterClick={() => {}}
        closeButtonAriaLabel={translator('ariaLabel.panelClose')}
      >
        <div>
          <div className="panel-content">
            <h3 className="panel-header">
              {translator(
                'pages.createHearing.createHearingInvitations.updateInvitationGroupInviteePanel.header',
              )}
            </h3>
            <Dropdown
              placeholder={translator(
                'pages.createHearing.createHearingInvitations.updateInvitationGroupInviteePanel.placeHolder',
              )}
              label={translator(
                'pages.createHearing.createHearingInvitations.updateInvitationGroupInviteePanel.guideText',
              )}
              selectedKey={selectedInvitationGroupId}
              onChange={onChange}
              options={invitationGroups.map(mapInvitationGroupToDropdown)}
              disabled={isUpdating}
            />
          </div>
          <div className="panel-buttons">
            {isUpdating && <Spinner size={SpinnerSize.large} />}
            <DefaultButton
              text={translator('global.cancel')}
              onClick={onPanelClose}
              disabled={isUpdating}
            />
            <PrimaryButton
              text={translator('global.confirm')}
              onClick={onConfirm}
              disabled={
                isUpdating || selectedInvitationGroupId === noSelectionKey
              }
            />
          </div>
        </div>
      </Panel>
    </div>
  );
};

export { UpdateInvitationGroupInviteePanel };
